import React, { useState, useEffect, useContext, useMemo } from "react";
import { API, graphqlOperation, Storage } from "aws-amplify";
import { notification, Spin } from "antd";
import { listProjects } from "../../graphql/queries";
import BTable from "react-bootstrap/Table";
import dateFormat from "dateformat";
import { Redirect } from "react-router-dom";
import { useTable } from "react-table";
import { LoadingOutlined } from "@ant-design/icons";
import { Context } from "../../Store.js";
import "./style.css";

const SearchArchivesPage = () => {
  const [state, dispatch] = useContext(Context);
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState({
    name: "",
    projectType: "",
    startDate: "",
    endDate: "",
  });

  const [redirect, setRedirect] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchProjects = async () => {
    setIsLoading(true);
    try {
      const projectData = await API.graphql(
        graphqlOperation(listProjects, {
          filter: {
            status: {
              eq: "ARCHIVED",
            },
            projectType: { eq: search.projectType },
            or: [
              { lowerCaseName: { contains: search.name.toLowerCase() } },
              { abstract: { contains: search.name } },
            ],
          },
        })
      );
      const projectList = projectData.data.listProjects.items;
      setProjects(projectList);
    } catch (error) {
      notification.error({
        message: "Error fetching projects!",
        description: error.message,
        placement: "topRight",
        duration: 1.5,
        onClose: () => {
          setRedirect(null);
          setIsLoading(false);
        },
      });
    }
    setIsLoading(false);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "projectName",
      },
      {
        Header: "Identification Number",
        accessor: "identificationNumber",
      },
      {
        Header: "Project Type",
        accessor: "projectType",
      },
      {
        Header: "Start Date",
        accessor: "startDate",
        Cell: (props) => (
          <span className="string">
            {dateFormat(props.value, "mmmm dS, yyyy")}
          </span>
        ),
      },
      {
        Header: "End Date",
        accessor: "endDate",
        Cell: (props) => (
          <span className="string">
            {dateFormat(props.value, "mmmm dS, yyyy")}
          </span>
        ),
      },
      {
        header: "",
        id: "click-me-button",
        Cell: (props) => <a className="btn btn-primary">View</a>,
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: projects,
    });

  const clickProject = async (project) => {
    dispatch({ type: "SET_SELECTED_PROJECT", payload: project });
    setRedirect(`archive-detail/${project.id}`);
  };
  if (redirect) {
    return <Redirect to={redirect} />;
  } else {
    return (
      <React.Fragment>
        <div
          className="container inner-class-container"
          style={{ height: "100%;" }}
        >
          <div className="form-group">
            <h2>Search Archived Projects</h2>
            <div className="form-group">
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search for a project by name"
                  onChange={(e) =>
                    setSearch({
                      ...search,
                      name: e.target.value,
                    })
                  }
                  value={search.name}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="projectType">Project Type</label>
              <select
                className="form-control"
                id="projectType"
                onChange={(e) =>
                  setSearch({ ...search, projectType: e.target.value })
                }
              >
                <option value="">------ Select Project Type ------</option>
                <option value="Journal Publication">Journal Publication</option>
                <option value="Technical Report">Technical Report</option>
                <option value="Research Proposals">Research Proposal</option>
                <option value="Conference Paper">Conference Paper</option>
                <option value="Seminar Paper">Seminar Paper</option>
                <option value="Workshop Paper">Workshop Paper</option>
              </select>
            </div>
            <div>
              <a onClick={fetchProjects} className="btn btn-primary">
                {isLoading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ fontSize: 24 }} />}
                  />
                ) : (
                  "Search"
                )}
              </a>
            </div>
          </div>
          <br />
          {projects.length > 0 ? (
            <BTable striped bordered hover size="sm" {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      onClick={() => clickProject(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </BTable>
          ) : (
            <h2>No Results</h2>
          )}
        </div>
      </React.Fragment>
    );
  }
};

export default SearchArchivesPage;
